import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  NbAuthJWTToken,
  NbAuthModule,
  NbAuthSimpleToken,
  NbDummyAuthStrategy,
  NbPasswordAuthStrategy,
} from "@nebular/auth";
import { NbSecurityModule, NbRoleProvider } from "@nebular/security";
import { throwIfAlreadyLoaded } from "./module-import-guard";
import {
  AnalyticsService,
  LayoutService,
  SeoService,
  StateService,
} from "./utils";
import { RoleProvider } from "../providers/role.provider";
import { UserData } from "./data/users";
import { UserService } from "../services/user.service";
import { environment as env } from "../../environments/environment";

// const socialLinks = [
//   {
//     url: "https://github.com/akveo/nebular",
//     target: "_blank",
//     icon: "github",
//   },
//   {
//     url: "https://www.facebook.com/akveo/",
//     target: "_blank",
//     icon: "facebook",
//   },
//   {
//     url: "https://twitter.com/akveo_inc",
//     target: "_blank",
//     icon: "twitter",
//   },
// ];

export const NB_CORE_PROVIDERS = [
  ...NbAuthModule.forRoot({
    strategies: [
      NbPasswordAuthStrategy.setup({
        name: "email",
        token: {
          class: NbAuthJWTToken,
          key: "authorization.token",
        },
        baseEndpoint: `${env.apiUrl}/auth`,
        login: {
          alwaysFail: false,
          endpoint: "/login",
          method: "post",
        },
        register: {
          endpoint: "/register",
          method: "post",
        },
        logout: {
          endpoint: "/logout",
          method: "post",
        },
        refreshToken: {
          endpoint: "/refresh",
          method: "post",
        }
      }),
    ],
    forms: {
      login: {
        strategy: "email",
      },
      register: {
        strategy: "email",
      },
    },
  }).providers,

  NbSecurityModule.forRoot({

  }).providers,

  {
    provide: NbRoleProvider,
    useClass: RoleProvider,
  },
  { 
    provide: UserData, 
    useClass: UserService 
  },
  AnalyticsService,
  LayoutService,
  SeoService,
  StateService,
];

@NgModule({
  imports: [CommonModule],
  exports: [NbAuthModule],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, "CoreModule");
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [...NB_CORE_PROVIDERS],
    };
  }
}
